import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-white py-20 lg:py-24" aria-labelledby="guarantee-heading" data-id="element-107" data-mp="1o3x3nprb6w3l">
      <div className="mx-auto grid max-w-content items-center gap-10 px-6 lg:grid-cols-[minmax(0,420px)_1fr] lg:gap-16" data-id="element-108" data-mp="223epbw9b5t8q">
        <div className="rounded-xl bg-ink-950 p-8 text-center text-white sm:p-10" data-id="element-109" data-mp="1x42054uysa2z">
          <ShieldCheckIcon className="mx-auto h-12 w-12 text-flare-500" aria-hidden="true" data-id="element-110" data-mp="19eheufbc90qj" />
          <p className="mt-5 text-3xl font-black leading-tight tracking-tight" data-id="element-111" data-mp="14fxswewqvoy6">
            7 días de garantía Hotmart
          </p>
          <p className="mt-2 text-sm font-bold uppercase tracking-[0.16em] text-flare-500" data-id="element-112" data-mp="1j5ltfdx3qjku">
            Reembolso 100% completo
          </p>
          <p className="mt-5 text-sm leading-relaxed text-white/65" data-id="element-113" data-mp="1ebr5fyagrify">
            Si no estás satisfecho por cualquier razón, solicita el reembolso en los primeros 7 días.
            Sin preguntas. Sin complicaciones.
          </p>
        </div>

        <div data-id="element-114" data-mp="p0b6ptplh6ew">
          <h2 id="guarantee-heading" className="text-3xl font-black leading-tight tracking-tight text-ink-950 sm:text-4xl" data-id="element-115" data-mp="oyqdc7f0ntim">
            La garantía es nuestro reto contigo
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-ink-600" data-id="element-116" data-mp="yp2ya0qqtopa">
            Conocemos el miedo: comprar en internet puede ser arriesgado. Por eso Hotmart y nosotros
            estamos 100% comprometidos contigo. Si después de leer los tomos o usar los bonos decides
            que no es lo que esperabas, tienes 7 días completos para solicitar tu dinero de vuelta.
            Sin preguntas. Sin ruegos.
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-ink-600" data-id="element-117" data-mp="ezsjcoytn7s8">
            Pero honestamente, el 99% de los principiantes que usan Drone Commander no solicitan
            reembolso. La razón: el contenido es tan directo y técnico que funciona desde el primer
            día.
          </p>
          <p className="mt-6 border-l-2 border-flare-500 pl-5 text-lg font-semibold leading-snug text-ink-950" data-id="element-118" data-mp="1ve0ttl6bhqni">
            No hay promesas exageradas. Hay resultados reales. O te sirve, o te devolvemos tu dinero.
          </p>
        </div>
      </div>
    </section>;
}